import { getMainDefinition } from '@apollo/client/utilities';
import type { DocumentNode, OperationVariables } from '@apollo/client';

function sortObjectKeys(_key: string, value: unknown): unknown {
  if (value == null || Array.isArray(value) || typeof value !== 'object') return value;

  const objectValue = value as Record<string, unknown>;
  return Object.fromEntries(
    Object.keys(objectValue)
      .sort()
      .map((key) => [key, objectValue[key]])
  );
}

export function getPrecacheOperationKey(
  query: DocumentNode,
  variables?: OperationVariables
): string {
  // GraphQL input-object field order has no semantic meaning. Canonicalize every
  // object so callers with equivalent variables address the same precache entry.
  const canonicalVariables = JSON.stringify(variables, sortObjectKeys);
  return (getMainDefinition(query).name?.value ?? 'unnamed-query') + canonicalVariables;
}
